import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import ConfirmationDialog from 'app/components/ConfirmationDialog'
import * as R from 'ramda'
import DangerousButton from 'app/components/DangerousButton'
import CancelButton from 'app/components/buttons/CancelButton'

const LabelId = {
  invalid: {
    [true]: 'rolesPermissions.deletingDialog.body.invalid.one',
    [false]: 'rolesPermissions.deletingDialog.body.invalid.group',
  },
  cancelButton: {
    [true]: 'action.ok',
    [false]: 'action.cancel',
  },
}

export default (props) => {
  const { deletingRoles, open, setOpen, onCancel, onConfirm, isPending } = props
  const { formatMessage } = useIntl()

  //guard
  if (R.isEmpty(deletingRoles) || !open) return null

  const isSomeRolesHasUser = R.any(R.propSatisfies((x) => x > 0, 'usersCount'))(
    deletingRoles,
  )

  const getBody = () => {
    if (isSomeRolesHasUser) {
      return (
        <FormattedMessage id={LabelId.invalid[deletingRoles.length === 1]} />
      )
    }

    return (
      <FormattedMessage
        id="rolesPermissions.deletingDialog.body"
        values={{
          deletedCount: deletingRoles.length,
        }}
      />
    )
  }

  return (
    <ConfirmationDialog
      open={open}
      setOpen={setOpen}
      title={formatMessage(
        { id: 'rolesPermissions.deletingDialog.title' },
        { deletedCount: deletingRoles.length },
      )}
      body={getBody()}
      CancelButton={
        <CancelButton onClick={onCancel}>
          <FormattedMessage id={LabelId.cancelButton[isSomeRolesHasUser]} />
        </CancelButton>
      }
      ConfirmButton={
        !isSomeRolesHasUser && (
          <DangerousButton onClick={onConfirm} isLoading={isPending}>
            <FormattedMessage id="action.delete" />
          </DangerousButton>
        )
      }
    />
  )
}
